import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import { connect } from 'react-redux';
// @ts-expect-error No types
import { CSSTransitionGroup } from 'react-transition-group';
import { HEFFALUMP } from 'HubStyleTokens/colors';
import partial from 'transmute/partial';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import * as PDFActions from '../../actions/PDFActions';
import PresentationRecord from '../../records/PresentationRecord';
import { getDarkBrandingColor } from '../../utils/color';
import { MAIN_CONTENT_ANCHOR } from '../../lib/constants';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import ViewPageDrawerItem from './ViewPageDrawerItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Copied from import { EDITABLE_CONTROLS_TRANSITION_TIMING } from 'HubStyleTokens/times';
const EDITABLE_CONTROLS_TRANSITION_TIMEOUT = 250;
const ABOVE_FOLD_ITEMS = 5;
class ViewPageDrawer extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      limitLoadedSlides: true
    };
    this.getBrandingColor = () => {
      const {
        primaryColor,
        secondaryColor
      } = this.props.presentation.brandingMetadata;
      return getDarkBrandingColor(primaryColor, secondaryColor, HEFFALUMP);
    };
    this.handleChangePageClick = index => {
      const {
        changePage
      } = this.props;
      const element = document.getElementById(MAIN_CONTENT_ANCHOR);
      if (element) element.focus();
      changePage(index);
    };
    this.renderSlides = () => {
      const {
        presentation,
        pageIndex
      } = this.props;
      const {
        limitLoadedSlides
      } = this.state;
      const slidesToRender = limitLoadedSlides ? presentation.slides.slice(0, ABOVE_FOLD_ITEMS) : presentation.slides;
      return slidesToRender.map((slide, index) => {
        return /*#__PURE__*/_jsx(ViewPageDrawerItem, {
          brandingColor: this.getBrandingColor(),
          selected: pageIndex === index,
          imageUrl: slide.thumbnailUrl,
          index: index,
          onClick: partial(this.handleChangePageClick, index)
        }, index);
      });
    };
    this.renderLoading = () => {
      const {
        presentation
      } = this.props;
      const {
        limitLoadedSlides
      } = this.state;
      if (limitLoadedSlides && presentation.slides.length > ABOVE_FOLD_ITEMS) {
        return /*#__PURE__*/_jsx(View, {
          inlineSize: "100%",
          children: /*#__PURE__*/_jsx(LoadingSpinner, {
            layout: "centered"
          })
        });
      }
      return null;
    };
    this.renderDrawer = () => {
      return /*#__PURE__*/_jsx(Flex, {
        flexShrink: 0,
        blockSize: "100%",
        children: /*#__PURE__*/_jsx(View, {
          overflowX: "hidden",
          overflowY: "auto",
          backgroundColor: "fill-surface-default",
          boxShadow: "100",
          "data-test-id": "view-page-drawer-container",
          children: /*#__PURE__*/_jsxs(Flex, {
            "aria-label": I18n.text('a11y.pageSelectorContainer'),
            padding: "400",
            backgroundColor: "fill-surface-default",
            flexDirection: "column",
            position: "relative",
            children: [this.renderSlides(), this.renderLoading()]
          })
        })
      });
    };
  }
  componentDidMount() {
    setTimeout(() => this.setState({
      limitLoadedSlides: false
    }), 1000);
  }
  render() {
    return /*#__PURE__*/_jsx(CSSTransitionGroup, {
      component: "div",
      transitionEnterTimeout: EDITABLE_CONTROLS_TRANSITION_TIMEOUT,
      transitionLeaveTimeout: EDITABLE_CONTROLS_TRANSITION_TIMEOUT,
      transitionName: "view-toolbar",
      children: this.props.open ? this.renderDrawer() : null
    });
  }
}
ViewPageDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  presentation: PropTypes.instanceOf(PresentationRecord).isRequired,
  pageIndex: PropTypes.number.isRequired,
  changePage: PropTypes.func.isRequired
};
export default connect(state => ({
  pageIndex: state.view.pdf.pageIndex
}), {
  changePage: PDFActions.changePage
})(ViewPageDrawer);